import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'
import { ExecuteOperationOnPipe, ModelWithForm } from '@morningtrain/react-resources'
import { Fieldset } from 'layouts'
import * as UI from 'ui'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import * as Displays from 'support/displays'
import * as Fields from 'support/fields'
import { StaticFilter } from '@morningtrain/react-filters'
import { CanUseModel } from '@morningtrain/react-auth'
import { Link } from '@morningtrain/react-navigation'
import CustomAction from 'support/actions/CustomAction'

export default function ContractSmartview ({ id = null }) {
  return (
    <ModelWithForm resourceName='employments.contracts' id={id}>
      <ExecuteOperationOnPipe namespace='api' resourceName='employments.contracts' operationName='index' />
      <MountSmartviewOnPipe
        smartview={payload => <ContractSmartview id={payload.response.model.id} />}
        replace={false}
      />

      <Translator namespace='hr.contracts'>
        <Smartview
          header={id !== null
            ? (
              <Displays.Text name='user.name' />
              )
            : (
              <Translation name='titles.contract' />
              )}
          footer={(
            <UI.ButtonWrap>
              {id !== null
                ? (
                  <>
                    <CanUseModel permission='app.contracts.sign'>
                      <Link newTab route='app.contracts.sign' parameters={{ contract: id }}>
                        <UI.Button>
                          <Translation name='tablet.signing.sign_contract' />
                        </UI.Button>
                      </Link>
                    </CanUseModel>
                    <CanUseModel permission='app.contracts.file'>
                      <Link newTab route='app.contracts.file' parameters={{ contract: id }}>
                        <UI.Button>
                          <UI.WithIcon icon={<UI.Icons.Download />}>
                            <Translation name='actions.file' />
                          </UI.WithIcon>
                        </UI.Button>
                      </Link>
                    </CanUseModel>
                    <CanUseModel permission='app.contracts.zip'>
                      <Link newTab route='app.contracts.zip' parameters={{ contract: id }}>
                        <UI.Button>
                          <UI.WithIcon icon={<UI.Icons.Download />}>
                            <Translation name='actions.zip' />
                          </UI.WithIcon>
                        </UI.Button>
                      </Link>
                    </CanUseModel>
                    <CustomAction action='prepare'>
                      <ExecuteOperationOnPipe namespace='api' resourceName='employments.contracts' operationName='index' />
                    </CustomAction>
                    <CustomAction action='activate'>
                      <ExecuteOperationOnPipe namespace='api' resourceName='employments.contracts' operationName='index' />
                    </CustomAction>
                    <CustomAction action='cancel' buttonProps={{ color: 'red' }}>
                      <ExecuteOperationOnPipe namespace='api' resourceName='employments.contracts' operationName='index' />
                    </CustomAction>
                  </>
                  )
                : (
                  <UI.SubmitButton>
                    <Translation name='generic.save' />
                  </UI.SubmitButton>
                  )}
            </UI.ButtonWrap>
        )}
        >
          <SmartviewContentSection>
            {id !== null
              ? (
                <UI.VerticalList border={false}>
                  <UI.DisplayWithTitle title={<Translation name='fields.contract_template.label' />}>
                    <Displays.Text name='template.name' />
                  </UI.DisplayWithTitle>
                  <UI.DisplayWithTitle title={<Translation name='fields.user_id.label' />}>
                    <Displays.Text name='user.name' />
                  </UI.DisplayWithTitle>
                  <UI.DisplayWithTitle title={<Translation name='fields.base_department.label' />}>
                    <Displays.Text name='department.name' />
                  </UI.DisplayWithTitle>
                  <UI.DisplayWithTitle title={<Translation name='fields.created_at.label' />}>
                    <Displays.Date name='created_at' />
                  </UI.DisplayWithTitle>
                </UI.VerticalList>
                )
              : (
                <Fieldset>
                  <Fields.ResourceSelector
                    name='contract_template_id'
                    optionsKey='name'
                    resourceName='employments.contract_templates'
                    placeholder='-'
                    label={<Translation name='fields.contract_template.label' />}
                  >
                    <StaticFilter name='status' value='active' />
                  </Fields.ResourceSelector>
                  <Fields.ResourceSelector
                    name='user_id'
                    optionsKey='name'
                    resourceName='users.users'
                    operationName='select'
                    placeholder='-'
                    label={<Translation name='fields.user_id.label' />}
                  />
                  <Fields.ResourceSelector
                    name='department_id'
                    optionsKey='name'
                    resourceName='departments'
                    placeholder='-'
                    label={<Translation name='fields.base_department.label' />}
                  />
                  <Fields.Date
                    name='created_at'
                    label={<Translation name='fields.created_at.label' />}
                  />
                </Fieldset>
                )}
          </SmartviewContentSection>
        </Smartview>
      </Translator>
    </ModelWithForm>
  )
}
